import { __exports as cohort } from "../../../../../../_virtual/cohort.js";
var hasRequiredCohort;
function requireCohort() {
  if (hasRequiredCohort) return cohort;
  hasRequiredCohort = 1;
  Object.defineProperty(cohort, "__esModule", { value: true });
  cohort.USER_GROUP_TYPE = void 0;
  cohort.USER_GROUP_TYPE = "User";
  return cohort;
}
export {
  requireCohort as __require
};
//# sourceMappingURL=cohort.js.map
